import axios, { AxiosResponse } from 'axios';

import IReportingEvent from '../interfaces/IReportingEvent';

export default class AxiosAdapter {
    public static async post(url: string, data?: IReportingEvent | undefined): Promise<AxiosResponse> {
        try {
            return (data) ? await axios.post(url, data) : await axios.post(url);
        } catch (err) {
            throw err;
        }
    }

    public static async get(url: string): Promise<AxiosResponse> {
        try {
            return axios.get(url);
        } catch (err) {
            throw err;
        }
    }
}
